module.exports = __webpack_public_path__ + "static/paper-2db745fe4a3248c5f63d08bee7fdc634.jpg";